import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpClientRequestService {
  public tokenValue: String = null;
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa('Factor12:VIRAJ12345')
    })
  };

  public httpOptionsIqvia = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Api_Key': 'e2d92041e7df4d7e9e6d48fc28d9d822'
    })
  }

  constructor(private _httpClient: HttpClient) { }

  Post(url: string, input: any): Observable<any> {
    return this._httpClient.post<any>(url, input, this.httpOptions);
  }

  PostIqvia(url: string, input: any): Observable<any> {
    return this._httpClient.post<any>(url, input, this.httpOptionsIqvia);
  }

  PostPharmacode(url: string, input: any): Observable<any> {
    const token = this.tokenValue;
    const httpPharmacodeToken = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };
    return this._httpClient.post<any>(url, input, httpPharmacodeToken);
  }
}
